import React from 'react';
import { TextInput } from '../../../ui-library';

type ClientSearchBarProps = {
    onSearch: (value: string) => void;
};

export const ClientSearchBar = ({ onSearch }: ClientSearchBarProps) => (
    <TextInput
        onChange={onSearch}
        search
    />
);
